import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddButton from "../../../Components/AddButton/AddButton";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import { CategoryList } from "./CategoryList";
import { TreatmentList } from "./TreatmentList";
import { genericFetchData } from "../../../Services/Service";
import TreatmentPopUp from "./TreatmentPopUp";
import { checkPermission } from "../../../Utils/Permissions";
import { getUserCode } from "../../../Storage/Datastore";

function Treatments() {
  const [show, setshow] = useState(0);
  const [category, setCategories] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [specialityId, setSpecialityId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);

  console.log("===========================treatments", specialityId);
  useEffect(() => {
    console.log("specialityId:", specialityId);
  }, [specialityId]);
  console.log(specialities, "specialities====");
  const [filter, setFilter] = useState({
    keyword: "",
    pageNo: 1,
    pageSize: 20,
  });
  const [modal, setModal] = useState({ isOpen: false });
  // const [treatmentFilterData, setTreatmentFilterData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  // const getCategories = async () => {
  //   const response = await genericFetchData(`/departments/all`, "GET");
  //   const status = response.status;
  //   const responseData = await response.json();
  //   if (status == 200) {
  //     setCategories(responseData.departments);
  //     getTreatments(responseData.departments[0].id);
  //   } else {
  //     console.log("=======error", responseData);
  //   }
  // };

  const getSpecialities = async (id) => {
    // 8
    const departmentId = id ? id : category[0]?.id;
    const response = await genericFetchData(
      `/specialization/byDepartment/${departmentId}`,
      "GET"
    );
    const { status } = response;
    const responseData = await response.json();
    if (status == 200) {
      setSpecialities(responseData);
    } else {
      console.log("===error", responseData);
    }
  };

  const getTreatmentBySpecialities = async (id) => {
    const specialityId = id ? id : specialities[0]?.id;
    const response = await genericFetchData(
      `/specialization/treatments?specialityId=${specialityId}`,
      "GET"
    );
    console.log(response);
    const { status } = response;
    const responseData = await response.json();
    if (status == 200) {
      setTreatments(responseData.treatments);
      console.log(responseData, "====treatbyspec");
    } else {
      console.log("===error", responseData);
    }
  };

  const deleteSpecialityTreatment = async (id) => {
    const response = await genericFetchData(
      `/specialization/delete/treatment`,
      "DELETE",
      { specialityId: specialityId, treatmentId: id }
    );

    if (response.status === 200) {
      getTreatmentBySpecialities();
      console.log("Treatment under specialization deleted successfully!");
    } else {
      console.error(
        "Error deleting treatment under specialization:",
        response.status
      );
    }
  };

  // const deleteSpecialization = async (id) => {
  //   const specialityId = id;
  //   const response = genericFetchData(`/specialization/delete/${id}`, "DELETE");
  //   const { status } = response;
  //   if (status == 200) {
  //     console.log("specialization deleted successfully!", status);
  //   } else {
  //     console.error("Error deleting specialization:", status);
  //   }
  // };

  // Treatments API

  const getTreatments = async (id) => {
    const departmentId = id ? id : category[0]?.id;
    const response = await genericFetchData(
      `/treatments/department/${departmentId}`,
      "GET"
    );
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setTreatments(responseData.treatments);
    } else {
      console.log("=======error", responseData);
    }
  };

  const getFilterdDepartment = async () => {
    const response = await genericFetchData(
      `/departments/filtered`,
      "POST",
      filter
    );
    const status = response.status;
    const responseData = await response.json();
    if (status === 200) {
      setCategories(responseData?.departments);
      getTreatments(responseData?.departments[0]?.id);
    } else {
      console.log("=======error", responseData);
    }
  };

  useEffect(() => {
    getFilterdDepartment();
  }, [filter]);

  const save = async (postData, id) => {
    if (id) {
      postData.departmentId = id;
    }
    const response = await genericFetchData(
      `/departments/save`,
      "POST",
      postData
    );
    const status = response.status;
    if (status == 200) {
      getFilterdDepartment();
      getTreatments(id);
    }
    console.log("=======error", status);
  };

  const treatmentSave = async (postData, id) => {
    console.log("====++==");
    if (id) {
      postData.treatmentId = id;
    }
    const response = await genericFetchData(
      `/treatments/save`,
      "POST",
      postData
    );
    const status = response.status;
    if (status == 200) {
      getTreatments(postData.departmentId);
    }
  };

  const deleteTreatment = async (id) => {
    const response = await genericFetchData(
      `/treatments/delete/${id}`,
      "DELETE"
    );
    const status = response.status;
    if (status == 200) {
      getTreatments(category[show].id);
    }
  };

  const deleteCategory = async (id) => {
    const userCode = getUserCode();
    const response = await genericFetchData(
      `/departments/delete/${id}?userCode=${userCode}`,
      "DELETE"
    );
    const status = response.status;
    if (status == 200 || status == 500) {
      getFilterdDepartment();
    }
  };

  const categoryAdd = { type: "CATEGORY", save: save };

  const newTreatment = { type: "TREATMENT", save: treatmentSave };
  const deleteBoxData = {
    type: "DELETE",
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
    deleteData: specialityId ? deleteSpecialityTreatment : deleteTreatment,
  };

  const approveData = {
    type: "APPROVE",
    handleApprove: save,
    buttons: [
      { id: 1, buttonName: "No" },
      { id: 2, buttonName: "Yes" },
    ],
  };

  const handleOpen = (data) => {
    setModal({ isOpen: true, data: data });
  };

  const handleApprovePopUpOpen = (data, checked, id) => (e) => {
    data.approve = e.target.checked;
    data.id = id;
    data.checked = checked;
    setModal({ isOpen: true, data: data });
  };

  return (
    <>
      <Grid
        sx={{
          width: "77%",
          height: "98vh",
          padding: "0px 25px",
          backgroundColor: "#F9FBFC",
          borderRadius: "15px",
        }}
      >
        <TreatmentPopUp
          data={modal}
          openModal={modal.isOpen}
          setOpenModal={setModal}
          specialitiesData={specialities}
          departmentId={departmentId}
        />

        <Grid
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "15px",
          }}
        >
          <Typography fontSize={"16px"} fontWeight={600} paddingY="15px">
            Category & Treatments
          </Typography>
          <Grid item paddingY="20px">
            <Grid item container justifyContent="space-between" lg={6}>
              <Grid
                item
                width={100}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography
                  fontSize={"15px"}
                  sx
                  fontWeight={600}
                  color="#2E2E2E"
                >
                  Categories
                </Typography>
              </Grid>
              <Grid item container justifyContent="space-between" width={440}>
                <Grid item lg={5.5} width={"100%"}>
                  <SearchBar
                    placeHolder={"Search category"}
                    onChagevalue={(e) =>
                      setFilter((s) => ({ ...s, keyword: e.target.value }))
                    }
                    width="100%"
                    borderRadius={"50px"}
                    backgroundColor="#ECF1F5"
                  />
                </Grid>
                <Grid item lg={5.5}>
                  {checkPermission("DB_CATEGORY_EDIT") && (
                    <AddButton
                      labelName={"Add New Category"}
                      onClick={() => {
                        handleOpen(categoryAdd);
                      }}
                      width={"90%"}
                      viewHeight={"40px"}
                      borderRadius={"50px"}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container item lg={12} height={500}>
            <Grid
              padding={1}
              item
              lg={6}
              height={"80vh"}
              overflow="auto"
              sx={{
                "&::-webkit-scrollbar": {
                  width: "5px",
                  backgroundColor: "#F5F5F5",
                },
                "&::-webkit-scrollbar-thumb": {
                  borderRadius: "4px",
                  backgroundColor: "#17dfba86",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "#17dfba",
                },
              }}
            >
              {category.length ? (
                category.map((val, i) => {
                  return (
                    <CategoryList
                      key={i}
                      approved={val.approved}
                      onChange={handleApprovePopUpOpen(
                        approveData,
                        val.approved,
                        val.id
                      )}
                      onEdit={() => {
                        categoryAdd.categoryValue = val;
                        categoryAdd.departmentId = val.id;
                        categoryAdd.delete = deleteCategory;
                        handleOpen(categoryAdd);
                      }}
                      selected={show == i}
                      category={val.name}
                      onClick={() => {
                        getTreatments(val.id);
                        getSpecialities(val.id);
                        setshow(i);
                        setDepartmentId(val?.id);
                        setSpecialityId(null);
                      }}
                    />
                  );
                })
              ) : (
                <></>
              )}
            </Grid>

            {/* right */}

            {/* Treatment Grids */}

            <Grid
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: "20px",
              }}
              paddingX={{ md: 6 }}
              item
              lg={6}
            >
              {/* Speciality container */}
              <Grid
                boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px;"
                borderRadius="10px"
                xl={12}
                md={12}
                width="100%"
              >
                <Grid
                  paddingTop={"15px"}
                  paddingLeft={"15px"}
                  marginBottom={"15px"}
                  container
                  justifyContent="space-between"
                  item
                  lg={12}
                >
                  <Typography
                    fontSize={"15px"}
                    fontWeight={600}
                    color="#1AC1A2"
                    // bgcolor={"yellow"}
                    sx={{ width: "100%" }}
                    paddingBottom={"8px"}
                  >
                    {" "}
                    Speciality Treatments
                  </Typography>
                  {/* <Grid item lg={6.5} paddingTop={"10px"} width={"100%"}>
                    <SearchBar
                      placeHolder={"Search speciality"}
                      // onChagevalue={(e) =>
                      //   setFilter((s) => ({ ...s, keyword: e.target.value }))
                      // }
                      width="100%"
                      backgroundColor="#ECF1F5"
                      borderRadius="20px"
                      height="35"
                    />
                  </Grid> */}
                  {/* <Grid
                    item
                    lg={4}
                    paddingTop={"4.5px"}
                    xl={3.4}
                    marginRight={3}
                  >
                    {checkPermission("DB_TREATMENT_EDIT") && (
                      <AddButton
                        labelName={"Add New"}
                        onClick={() => {
                          handleOpen(categoryAdd);
                        }}
                        width={"100%"}
                        viewHeight={"35px"}
                        borderRadius={"50px"}
                      />
                    )}
                  </Grid> */}
                </Grid>
                <Grid
                  maxHeight="25vh"
                  overflow="scroll"
                  // bgcolor={"purple"}
                  sx={{
                    overflowX: "hidden",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      backgroundColor: "#F5F5F5",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      borderRadius: "4px",
                      backgroundColor: "#17dfba86",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#17dfba",
                    },
                  }}
                >
                  {specialities?.length
                    ? specialities.map((val, i) => {
                        return (
                          <TreatmentList
                            noIcon
                            key={i}
                            handleDelete={() => {
                              deleteBoxData.deletedId = val.id;
                              handleOpen(deleteBoxData);
                            }}
                            handleEdit={() => {
                              newTreatment.departmentId = category[show].id;
                              newTreatment.treatmentId = val.id;
                              newTreatment.treatmentValue = val;
                              handleOpen(newTreatment);
                            }}
                            name={val.name}
                            onClick={() => {
                              getTreatmentBySpecialities(val.id);
                              setSpecialityId(val.id);
                            }}
                          />
                        );
                      })
                    : null}
                </Grid>
              </Grid>
              <Grid
                boxShadow="rgba(149, 157, 165, 0.2) 0px 8px 24px;"
                borderRadius="10px"
                height="35vh"
                xl={12}
                md={12}
                width="100%"
              >
                {/* Treatments container */}
                <Grid
                  paddingTop={"15px"}
                  paddingLeft={"15px"}
                  marginBottom={"15px"}
                  container
                  justifyContent="space-between"
                  item
                  lg={12}
                >
                  <Typography
                    fontSize={"15px"}
                    fontWeight={600}
                    color="#1ac1a2"
                    sx={{ width: "100%" }}
                    paddingBottom={"8px"}
                  >
                    {" "}
                    Treatments
                  </Typography>
                  <Grid item lg={6.5} paddingTop={"5px"} width={"100%"}>
                    <SearchBar
                      placeHolder={"Search treatments"}
                      // onChagevalue={(e) =>
                      //   setFilter((s) => ({ ...s, keyword: e.target.value }))
                      // }
                      width="100%"
                      backgroundColor="#ECF1F5"
                      borderRadius="20px"
                      height="35"
                    />
                  </Grid>
                  <Grid
                    item
                    lg={4}
                    paddingTop={"4.5px"}
                    xl={3.4}
                    marginRight={3}
                  >
                    {checkPermission("DB_TREATMENT_EDIT") && (
                      <AddButton
                        labelName={"Add New"}
                        onClick={() => {
                          handleOpen(newTreatment);
                          getFilterdDepartment();
                        }}
                        width={"100%"}
                        viewHeight={"35px"}
                        borderRadius={"50px"}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid
                  maxHeight="25vh"
                  // bgcolor={"pink"}
                  overflow="scroll"
                  sx={{
                    overflowX: "hidden",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      backgroundColor: "#F5F5F5",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      borderRadius: "4px",
                      backgroundColor: "#17dfba86",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#17dfba",
                    },
                  }}
                >
                  {treatments?.length
                    ? treatments.map((val, i) => {
                        return (
                          <TreatmentList
                            key={i}
                            handleDelete={() => {
                              deleteBoxData.deletedId = val.id;
                              handleOpen(deleteBoxData);
                              console.log(val.id, "val");
                              console.log(specialityId, "sp id");
                            }}
                            handleEdit={() => {
                              newTreatment.departmentId = category[show].id;
                              newTreatment.treatmentId = val.id;
                              newTreatment.treatmentValue = val;
                              handleOpen(newTreatment);
                            }}
                            name={val.name}
                          />
                        );
                      })
                    : null}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default Treatments;
